<section class="page-wrap animated fadeIn">
  <header class="pattern-header">
    Products
  </header>
  <div class="products mb-5">
    <div class="row g-3 landing-container">
      @for (item of products(); track $index) {
      <div class="col-12 col-sm-6 col-md-4 p-0 animated fadeInDown">
        <div class="product-card">
          <img src="/assets/images/landing/about/products/{{item.img}}" alt="Image of {{item.title}}" />
          <div class="product-card__container">
            <div>
              <span class="title">
                {{item.title}}
              </span>

              @if (item.isOtherProducts) {
              <p class="h7-semibold">
                We collaborate with <strong>trusted producers who align with our values</strong>, offering a curated
                selection of premium goods:
              </p>
              <ul>
                <li class="h7-semibold">
                  Honey
                </li>
                <li class="h7-semibold">
                  Cultured Products
                </li>
                <li class="h7-semibold">
                  Broth
                </li>
                <li>
                  Granolas
                </li>
                <li class="h7-semibold">
                  Grains
                </li>
                <li class="h7-semibold">
                  Nuts
                </li>
                <li class="h7-semibold">
                  Oils
                </li>
                <li class="h7-semibold">
                  Snacks
                </li>
                <li class="h7-semibold">
                  Spices
                </li>
                <li class="h7-semibold">
                  Personal Care
                </li>
              </ul>
              <p class="h7-semibold">
                Exceptional products sourced from farmers and artisans who share our commitment to quality and
                sustainability.
              </p>
              <a class="h7-bold float-end" href="javascript:void(0)" [routerLink]="['/pages/producers']">
                View Producers
              </a>
              } @else {
              <p class="description">
                {{item.descriptionArray?.[0] ?? ''}}
              </p>
              <a class="h7-bold float-end" href="javascript:void(0)" (click)="readMore(item)">
                Read More
              </a>
              }

            </div>
            <button class="btn btn-primary" type="button" [routerLink]="['/shop']">
              Shop now
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</section>